module.exports = __webpack_public_path__ + "img/mailIcon.a98a788b.svg";